import { FiChevronRight } from 'react-icons/fi';
import Card from '../common/Card';
import Button from '../common/Button';
import { Icon } from '../common/Icon';

/**
 * SectionCard — the dashboard's titled panel: Card with a serif header row
 * (tinted line icon + title + optional subtitle) and an optional right-aligned
 * ghost action ("View All ›"). Body renders below the divider.
 */
export default function SectionCard({ icon, iconTone = '#145f5f', title, subtitle, action, children, className = '' }) {
  return (
    <Card padded={false} className={`overflow-hidden ${className}`}>
      <div className="px-4 py-3 border-b flex items-center gap-2" style={{ borderColor: 'rgba(226, 217, 200, 0.55)' }}>
        <div className="flex-1 min-w-0">
          <div
            className="text-[17.5px] font-bold tracking-wide flex items-center gap-2 text-[#08111f]"
            style={{ fontFamily: 'var(--font-serif)' }}
          >
            {icon && <Icon name={icon} size={16} style={{ color: iconTone }} />}
            {title}
          </div>
          {subtitle && <div className="text-[10.5px] text-[#7a7060]">{subtitle}</div>}
        </div>
        {action && (
          <Button
            variant="ghost"
            size="sm"
            className="group shrink-0 !py-1 !px-2.5 text-[11px] font-semibold hover:!bg-[#8a6a1f]/[0.08] hover:!text-[#8a6a1f]"
            rightIcon={<FiChevronRight size={12} className="transition-transform duration-200 group-hover:translate-x-0.5" />}
            onClick={action.onClick}
          >
            <span className="transition-transform duration-200 group-hover:translate-x-0.5">{action.label}</span>
          </Button>
        )}
      </div>
      {children}
    </Card>
  );
}
